const formatCurrency = (
  value: number | string | undefined | null,
  minimumFractionDigits = 0,
  currency = "USD"
): string => {
  const toBeFormatted = value ?? 0;

  if (typeof toBeFormatted === "string") return toBeFormatted;

  return Intl.NumberFormat("en-US", {
    currency,
    minimumFractionDigits:
      minimumFractionDigits === 0 && !Number.isInteger(value)
        ? 2
        : minimumFractionDigits,
    style: "currency",
  }).format(toBeFormatted);
};

export { formatCurrency };
